export default (store) => {
  let state = store.state;
  // 初始化state
  store.replaceState(
    Object.assign({}, state, JSON.parse(sessionStorage.getItem("store")))
  );
  store.subscribe((mutation, state) => {
    sessionStorage.setItem("store", JSON.stringify(state));
  });
};
